/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-closing-tag-location */
import React from 'react';
import { Link } from 'react-router-dom';

function NewProfessionQuoteInfo({ professionQuote, setShowGreeniaAI }) {
    const quote = professionQuote.quote;

    return (
        <div className="w-75 ms-auto mb-3">
            <div className="bg-success border border-success p-3 rounded-3 shadow">
                <h5 className="fs-6 text-white">Nuovo Preventivo RC Professionale</h5>
                <hr />
                <div>
                    <div>
                        <div className="row">
                            {quote?.company && (
                                <div className="col-6">
                                    <p className="m-0 text-white">
                                        <small>
                                            <strong>
                                                Compagnia:
                                            </strong>
                                            <br />
                                            {quote?.company}
                                        </small>
                                    </p>
                                </div>
                            )}
                            {quote?.fatturato && (
                                <div className="col-6">
                                    <p className="m-0 text-white">
                                        <small>
                                            <strong>
                                                Fatturato:
                                            </strong>
                                            <br />
                                            {Number(quote?.fatturato).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })}
                                        </small>
                                    </p>
                                </div>
                            )}
                            {quote?.max_billed && (
                                <div className="col-6">
                                    <p className="m-0 text-white">
                                        <small>
                                            <strong>
                                                Massimale:
                                            </strong>
                                            <br />
                                            {Number(quote?.max_billed).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })}
                                        </small>
                                    </p>
                                </div>
                            )}
                            {(quote?.risks && quote?.risks?.length > 0) && (
                                <>

                                    {quote?.risks.map((risk, index) => (
                                        <div className="col-6" key={index}>
                                            <p className="m-0 text-white">
                                                <small>
                                                    <strong>
                                                        {risk?.name}
                                                    </strong>
                                                    <br />
                                                    {parseFloat(risk?.price).toFixed(2)}
                                                    {' '}
                                                    €
                                                </small>
                                            </p>
                                        </div>
                                    ))}
                                </>
                            )}

                            {quote?.totalPrice && (
                                <div className="col-6">
                                    <p className="m-0 text-white">
                                        <small>
                                            <strong>
                                                Prezzo Totale:
                                            </strong>
                                            <br />
                                            {parseFloat(quote?.totalPrice).toFixed(2)}
                                            {' '}
                                            €
                                        </small>
                                    </p>
                                </div>
                            )}
                        </div>
                        <hr />
                        <div className="row mt-2">
                            <div className="col-12">
                                <Link
                                    onClick={() => setShowGreeniaAI(false)}
                                    className="btn btn-light"
                                    to={`/quote/profession/${professionQuote.fastQuoteId}`}
                                >
                                    Procedi con il Preventivo
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NewProfessionQuoteInfo;
